// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AuditHour = zod.object({
  "hour": zod.iso.datetime({"offset":true}),
  "outcomes": zod.record(zod.string(), zod.int())
});

export type AuditHour = zod.input<typeof AuditHour>;
export type AuditHourOutput = zod.output<typeof AuditHour>;
